import { TrainingAnswerTime } from './components/TrainingAnswerTime';
import { TrainingCorrectNumber } from './components/TrainingCorrectNumber';
import { TrainingPlayTime } from './components/TrainingPlayTime';
import { TrainingRanking } from './components/TrainingRanking';
import { TrainingSceneEndCount } from './components/TrainingSceneEndCount';
import { TrainingScenePointAverage } from './components/TrainingScenePointAverage';
import { TrainingSceneScoreResult } from './components/TrainingSceneScoreResult';

interface GraphAreaTrainingProps {
  sceneEndCount: string;
  sceneCorrectRate: string;
  rankingData: any[];
  sceneScoreResultData: any[];
  playTimeData: any[];
  correctCountData: any[];
  averageAnswerTimeData: any[];
}

const GraphAreaTraining: React.FC<GraphAreaTrainingProps> = ({
  sceneEndCount,
  sceneCorrectRate,
  rankingData,
  sceneScoreResultData,
  playTimeData,
  correctCountData,
  averageAnswerTimeData,
}) => {
  return (
    <>
      <div className="mt-[200px] min-h-min min-w-min">
        <div className="grid grid-cols-1 3xl:grid-cols-2">
          <div className="grid-item flex">
            <div className="flex-1">
              <TrainingSceneEndCount data={sceneEndCount}></TrainingSceneEndCount>
            </div>
            <div className="flex-1">
              <TrainingScenePointAverage data={sceneCorrectRate}></TrainingScenePointAverage>
            </div>
          </div>
          <div className="grid-item">
            <TrainingRanking data={rankingData}></TrainingRanking>
          </div>
          <div className="grid-item flex flex-col">
            <TrainingSceneScoreResult data={sceneScoreResultData}></TrainingSceneScoreResult>
            <TrainingPlayTime data={playTimeData}></TrainingPlayTime>
          </div>
          <div className="grid-item flex flex-col">
            <TrainingCorrectNumber data={correctCountData}></TrainingCorrectNumber>
            <TrainingAnswerTime data={averageAnswerTimeData}></TrainingAnswerTime>
          </div>
        </div>
      </div>
    </>
  );
};
export { GraphAreaTraining };
